import * as React from 'react';

import * as styles from './PromoBlackFridayBadge.css';

interface IPromoBlackFridayBadgeProps {
  size: number;
}

export const PromoBlackFridayBadge: React.FC<IPromoBlackFridayBadgeProps> = ({ size }) => {
  const style = {
    width: `${size}px`,
    height: `${size}px`,
  };

  return <div className={styles['container']} style={style} />;
};
